<div class="input input-{{ input.template.type }}">
  <div class="group-wrapper">
    <label [title]="input.template.details.name">
      <span *ngIf="input.template.details.required" class="asterisk c-red">*</span>
      <text-highlight [text]="input.template.details.name + ':'" [pattern]="searchPattern"></text-highlight>
    </label>
    <ng-container [ngSwitch]="input.template.type">
      <ng-container *ngSwitchCase="'Checkbox'">
        <div class="input-wrapper">
          <trg-checkbox appearance="square"
                        class="dataset-editor-input-{{ input.id }}"
                        [disabled]="disabled"
                        [readonly]="readonly"
                        [(value)]="checkboxValue"
                        (valueChange)="onCheckboxChange($event)"></trg-checkbox>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'Text'">
        <div class="input-wrapper">
          <input
            class="trg-outline w-100p fs-12 dataset-editor-input-{{ input.id }}"
            type="text"
            [disabled]="disabled"
            [readonly]="readonly"
            [maxlength]="$any(input.template).maxLength"
            [(ngModel)]="textValue"
            (ngModelChange)="onTextChange($event)"
            [required]="input.template.details.required"
          />
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'Number'">
        <div class="input-wrapper">
          <input
            class="trg-outline w-100p fs-12 dataset-editor-input-{{ input.id }}"
            type="text"
            [disabled]="disabled"
            [readonly]="readonly"
            [maxlength]="$any(input).maxLength"
            [(ngModel)]="textValue"
            (ngModelChange)="onTextChange($event)"
            [required]="input.template.details.required"
          />
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'WholeNumber'">
        <div class="input-wrapper">
          <input
            class="trg-outline w-100p fs-12 dataset-editor-input-{{ input.id }}"
            type="text"
            [disabled]="disabled"
            [readonly]="readonly"
            [maxlength]="$any(input).maxLength"
            [(ngModel)]="textValue"
            (ngModelChange)="onTextChange($event)"
            [required]="input.template.details.required"
          />
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'Currency'">
        <div class="input-wrapper">
          <input
            class="trg-outline w-100p fs-12 dataset-editor-input-{{ input.id }}"
            type="text"
            [disabled]="disabled"
            [readonly]="readonly"
            [maxlength]="$any(input).maxLength"
            [(ngModel)]="textValue"
            (ngModelChange)="onTextChange($event)"
            [required]="input.template.details.required"
          />
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'CurrencyRange'">
        <div class="input-wrapper">
          <input
            class="trg-outline w-100p fs-12 dataset-editor-input-{{ input.id }}"
            type="text"
            [disabled]="disabled"
            [readonly]="readonly"
            [maxlength]="$any(input).maxLength"
            [(ngModel)]="textValue"
            (ngModelChange)="onTextChange($event)"
            [required]="input.template.details.required"
          />
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'Date'">
        <div class="input-wrapper">
          <div class="date-input-wrapper">
            <input
              class="trg-outline pointer w-100p fs-12 dataset-editor-input-{{ input.id }}"
              [disabled]="disabled || readonly"
              [matDatepicker]="picker"
              [(ngModel)]="startDate"
              (ngModelChange)="onStartDateChange($event)"
              (click)="picker.open()"
              readonly
              [required]="input.template.details.required"
            />
            <mat-datepicker-toggle matSuffix [for]="picker">
              <i class="far fa-calendar-alt i-16 p-relative not-2 mr-6" matDatepickerToggleIcon></i>
            </mat-datepicker-toggle>
            <mat-datepicker #picker [disabled]="disabled"></mat-datepicker>
            <i *ngIf="showStartDateClearValue()" class="far fa-times select-clear-btn" (click)="clearStartDateValue()"></i>
          </div>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'DateRange'">
        <div class="input-wrapper d-flex justify-content-between date-range-input-wrapper">
          <div class="date-input-wrapper">
            <input
              class="trg-outline pointer w-100p fs-12 dataset-editor-input-{{ input.id }}"
              [disabled]="disabled || readonly"
              [matDatepicker]="startDatePicker"
              [(ngModel)]="startDate"
              (ngModelChange)="onStartDateChange($event)"
              (click)="startDatePicker.open()"
              readonly
              [required]="input.template.details.required"
            />
            <mat-datepicker-toggle matSuffix [for]="startDatePicker">
              <i class="far fa-calendar-alt i-16 p-relative not-2 mr-6" matDatepickerToggleIcon></i>
            </mat-datepicker-toggle>
            <mat-datepicker #startDatePicker [disabled]="disabled"></mat-datepicker>
            <i *ngIf="showStartDateClearValue()" class="far fa-times select-clear-btn" (click)="clearStartDateValue()"></i>
          </div>

          <span class="mx-10">to</span>

          <div class="date-input-wrapper">
            <input
              class="trg-outline pointer w-100p fs-12 dataset-editor-input-{{ input.id }}"
              [disabled]="disabled || readonly"
              [matDatepicker]="endDatePicker"
              [(ngModel)]="endDate"
              (ngModelChange)="onEndDateChange($event)"
              (click)="endDatePicker.open()"
              readonly
              [required]="input.template.details.required"
            />
            <mat-datepicker-toggle matSuffix [for]="endDatePicker">
              <i class="far fa-calendar-alt i-16 p-relative not-2 mr-6" matDatepickerToggleIcon></i>
            </mat-datepicker-toggle>
            <mat-datepicker #endDatePicker [disabled]="disabled"></mat-datepicker>
            <i *ngIf="showEndDateClearValue()" class="far fa-times select-clear-btn" (click)="clearEndDateValue()"></i>
          </div>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'Dropdown'">
        <div class="input-wrapper input-dropdown p-relative">
          <mat-select
            #dropdownMatSelect
            [compareWith]="dropdownCompareWith"
            [disableOptionCentering]="true"
            [disabled]="disabled"
            [class.mat-readonly]="readonly || loadingDropdownOptions"
            class="trg-outline fs-12 dataset-editor-input-{{ input.id }}"
            [class.can-clear]="showClearDropdownValue()"
            [(ngModel)]="dropdownValue"
            (ngModelChange)="onDropdownChange($event)"
            [required]="input.template.details.required"
            (openedChange)="dropdownOpenedChange($event)"
            panelClass="dataset-editor-input-dropdown-panel
                        {{ dropdownColumns ? 'dropdown-columns' : '' }}
                        {{ $any(input.template).multiple ? 'dropdown-multiple' : '' }}"
            [multiple]="$any(input.template).multiple"
            [placeholder]="dropdownPlaceholder"
            [title]="dropdownLabel"
          >
            <mat-select-trigger [title]="dropdownLabel">
              <div class="d-inline-block text-ellipsis trigger-text">
                {{ dropdownLabel ?? "&nbsp;" }}
              </div>
            </mat-select-trigger>

            <mat-option *ngIf="searchable" class="hide-checkbox search-option">
              <ngx-mat-select-search
                [formControl]="dropdownSearchControl"
                placeholderLabel="Enter Text"
                noEntriesFoundLabel="No options found"
                [clearSearchInput]="false"
                [hideClearSearchButton]="true"
              ></ngx-mat-select-search>
            </mat-option>

            <mat-option *ngIf="dropdownColumns?.length" [disabled]="true" class="dropdown-columns-header-option">
              <div class="option-props-header" [style]="dropdownColumnsGridStyle">
                <div *ngFor="let c of dropdownColumns" class="text-ellipsis" [title]="c">
                  {{ c }}
                </div>
              </div>
            </mat-option>

            <cdk-virtual-scroll-viewport
              itemSize="24"
              [style.height.px]="getViewportHeight()"
              orientation="vertical"
              *ngIf="dropdownOptionsLoaded && dropdownOptions?.length && !loadingDropdownOptions"
            >
              <ng-container *ngIf="dropdownOptions.length <= 500">
                <ng-container *ngFor="let opt of dropdownOptions; trackBy: dropdownTrackBy">
                  <mat-option [value]="opt" class="dropdown-option">
                    <ng-container *ngIf="dropdownColumns">
                      <div class="option-props" [style]="dropdownColumnsGridStyle">
                        <ng-container *ngIf="opt.properties?.length">
                          <ng-container *ngFor="let c of dropdownColumns; index as i">
                            <div *ngIf="opt.properties?.length && i < opt.properties.length" class="text-ellipsis" [title]="opt.properties[i].value">
                              <text-highlight [text]="opt.properties[i].value" [pattern]="dropdownOptionsFilter"></text-highlight>
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!dropdownColumns">
                      <text-highlight [text]="opt.label" [pattern]="dropdownOptionsFilter"></text-highlight>
                    </ng-container>
                  </mat-option>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="dropdownOptions.length > 500">
                <ng-container *cdkVirtualFor="let opt of dropdownOptions; trackBy: dropdownTrackBy">
                  <mat-option [value]="opt" class="dropdown-option">
                    <ng-container *ngIf="dropdownColumns">
                      <div class="option-props" [style]="dropdownColumnsGridStyle">
                        <div *ngFor="let c of dropdownColumns; index as i" class="text-ellipsis" [title]="opt.properties[i].value">
                          <text-highlight [text]="opt.properties[i].value" [pattern]="dropdownOptionsFilter"></text-highlight>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!dropdownColumns">
                      <text-highlight [text]="opt.label" [pattern]="dropdownOptionsFilter"></text-highlight>
                    </ng-container>
                  </mat-option>
                </ng-container>
              </ng-container>
            </cdk-virtual-scroll-viewport>

            <mat-option [hidden]="loadingDropdownOptions || !dropdownOptionsLoaded || dropdownOptions?.length" class="hide-checkbox">
              <span>No options found.</span>
            </mat-option>

            <mat-option [hidden]="!searchTermNotLongEnough" class="hide-checkbox">
              <span *ngIf="minSearchTermLength < 2">Please input a search term.</span>
              <span *ngIf="minSearchTermLength >= 2">Please input at least {{ minSearchTermLength }} characters.</span>
            </mat-option>

            <mat-option [hidden]="!loadingDropdownOptions" [disabled]="true" class="hide-checkbox loading-rect">
              <loading-rect size="100% 16px" class="d-inline-block br-4"></loading-rect>
            </mat-option>
            <mat-option [hidden]="!loadingDropdownOptions" [disabled]="true" class="hide-checkbox loading-rect">
              <loading-rect size="100% 16px" class="d-inline-block br-4"></loading-rect>
            </mat-option>
            <mat-option [hidden]="!loadingDropdownOptions" [disabled]="true" class="hide-checkbox loading-rect">
              <loading-rect size="100% 16px" class="d-inline-block br-4"></loading-rect>
            </mat-option>

            <!-- dummy option to force the label showing in the select;
            without this the select seems to hide the label while loading -->
            <mat-option [hidden]="true" [value]="dropdownValue" class="hide-checkbox">{{ dropdownLabel }}</mat-option>

            <mat-option *ngIf="defaultOption" [hidden]="true" [value]="defaultOption.value" class="hide-checkbox">{{ defaultOption.label ?? "" }}</mat-option>
          </mat-select>
          <div *ngIf="showDropdownCount()" class="count">({{ $any(dropdownValue).length }})</div>
          <i *ngIf="showClearDropdownValue()" class="far fa-times select-clear-btn" (click)="clearDropdownValue()"></i>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'RelativeDates'">
        <ng-container *ngTemplateOutlet="relativeDatesInput"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'RelativeYearPeriod'">
        <ng-container *ngTemplateOutlet="relativeDatesInput; context: { noDate: true }"></ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="'YearPeriod'">
        <ng-container *ngTemplateOutlet="yearPeriodInput"></ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="'NumberRange'">
        <div class="d-flex align-items-center flex-wrap" style="width: 290px">
          <div class="d-inline-flex align-items-center">
            <span>From</span>
            <input
              class="trg-outline fs-12 dataset-editor-input-{{ input.id }} ml-10"
              style="width: 110px"
              type="number"
              [disabled]="disabled"
              [readonly]="readonly"
              [(ngModel)]="numberRangeValue1"
              (ngModelChange)="onValueChange()"
              [required]="input.template.details.required"
            />
          </div>
          <div class="d-inline-flex align-items-center" style="margin-left: 11px">
            <span>to</span>
            <input
              class="trg-outline fs-12 dataset-editor-input-{{ input.id }} ml-10"
              style="width: 110px"
              type="number"
              [disabled]="disabled"
              [readonly]="readonly"
              [(ngModel)]="numberRangeValue2"
              (ngModelChange)="onValueChange()"
              [required]="input.template.details.required"
            />
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #relativeDatesInput let-noDate="noDate">
  <div class="w-100p">
    <div class="input-wrapper mb-10">
      <trg-checkbox
        appearance="circle"
        size="tiny"
        class="mr-20"
        [readonly]="readonly"
        [hideBorder]="true"
        [value]="!relativeDates"
        (click)="toggleRelativeDates(false)"
      >
        Specific dates
      </trg-checkbox>
      <trg-checkbox appearance="circle" size="tiny" [readonly]="readonly" [hideBorder]="true" [value]="relativeDates" (click)="toggleRelativeDates(true)">
        Relative dates
      </trg-checkbox>
    </div>
    <ng-container *ngIf="relativeDates">
      <div class="input-wrapper mb-10">
        <div class="d-flex align-items-center flex-wrap">
          <mat-select
            class="trg-outline mr-8 dataset-editor-input-{{ input.id }} fs-12"
            panelClass="trg-outline-dropdown  fs-12"
            style="width: 90px"
            [(ngModel)]="relativeDatesOperator"
            (ngModelChange)="onValueChange()"
          >
            <mat-option [value]="1">In the last</mat-option>
            <mat-option [value]="3">In the next</mat-option>
            <mat-option [value]="2">In this</mat-option>
            <mat-option [value]="4">Range</mat-option>
          </mat-select>
          <div class="d-flex align-items-center" [class.mt-10]="isRange" [style]="isRange ? 'flex: 1 0 100%' : 'flex: 1 0 0'">
            <span class="d-block" style="width: 74px" *ngIf="isRange">In the last</span>
            <input
              *ngIf="showUnitCount"
              class="trg-outline mr-8 dataset-editor-input-{{ input.id }}"
              type="number"
              min="1"
              max="{{ relativeMaxUnits }}"
              style="width: calc(100% - 136px); max-width: 80px"
              [(ngModel)]="relativeDatesValue.unitsCount"
              (ngModelChange)="onValueChange()"
              onkeydown="return false"
              [required]="input.template.details.required || !!relativeDatesValue.units2Count"
            />
            <mat-select class="trg-outline fs-12"
                        panelClass="trg-outline-dropdown fs-12"
                        style="width: 128px" 
                        [(ngModel)]="relativeDatesValue.unitType" 
                        (ngModelChange)="onValueChange()">
              <mat-option *ngFor="let unit of relativeDateUnits" [value]="unit.id">
                {{ showSingularTitles ? unit.titleSingular : unit.title }}
              </mat-option>
            </mat-select>
          </div>
        </div>
        <ng-container *ngIf="isRange">
          <span class="d-block my-6 fs-12 range-separator-label">And</span>

          <div class="d-flex align-items-center">
            <span class="d-block" style="width: 74px">In the next</span>
            <input
              *ngIf="showUnitCount"
              class="trg-outline mr-8 dataset-editor-input-{{ input.id }}"
              type="number"
              min="1"
              max="{{ relativeMaxUnits2 }}"
              style="width: calc(100% - 136px); max-width: 80px"
              onkeydown="return false"
              [(ngModel)]="relativeDatesValue.units2Count"
              (ngModelChange)="onValueChange()"
              [required]="input.template.details.required || !!relativeDatesValue.unitsCount"
            />
            <mat-select class="trg-outline" style="width: 128px" [(ngModel)]="relativeDatesValue.unit2Type" (ngModelChange)="onValueChange()">
              <mat-option *ngFor="let unit of relativeDateUnits" [value]="unit.id">
                {{ showSingularTitles ? unit.titleSingular : unit.title }}
              </mat-option>
            </mat-select>
          </div>
        </ng-container>

        <div class="filter-input mt-8 nmb-4">
          <div class="include-today" *ngIf="showIncludeToday">
            <trg-checkbox size="tiny" appearance="square" [hideBorder]="true" [(value)]="relativeDatesValue.includeToday" (valueChange)="onValueChange()">
              <ng-container *ngIf="!isSpendUnit">Include Today</ng-container>
              <ng-container *ngIf="isSpendUnit">Include Current Period</ng-container>
            </trg-checkbox>
          </div>
        </div>
      </div>
      <ng-container *ngIf="filterValuesSub | async as filterValues">
        <app-relative-date-range *ngIf="filterValues" [filter]="filterValues" [billingCenter]="spendBillingCenter"></app-relative-date-range>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!relativeDates">
      <div class="input-wrapper d-flex justify-content-between date-range-input-wrapper">
        <span class="mr-10">From</span>
        <div class="date-input-wrapper">
          <input
            class="trg-outline pointer w-100p fs-12 dataset-editor-input-{{ input.id }}"
            [max]="endDate"
            [min]="minDate"
            [disabled]="disabled || readonly"
            [matDatepicker]="startDatePicker"
            [(ngModel)]="startDate"
            (ngModelChange)="onStartDateChange($event)"
            (click)="startDatePicker.open()"
            readonly
            [required]="input.template.details.required || !!endDate"
          />
          <mat-datepicker-toggle matSuffix [for]="startDatePicker">
            <i class="far fa-calendar-alt i-16 p-relative mr-5" matDatepickerToggleIcon></i>
          </mat-datepicker-toggle>
          <mat-datepicker
            #startDatePicker
            [disabled]="disabled"
            startView="multi-year"
            (monthSelected)="relativeDatesStartDateMonthSelected($event, startDatePicker)"
            [panelClass]="noDate ? 'noDate' : ''"
          ></mat-datepicker>
          <i *ngIf="showStartDateClearValue()" class="far fa-times select-clear-btn" (click)="clearStartDateValue()"></i>
        </div>
        <span class="mx-10">to</span>
        <div class="date-input-wrapper">
          <input
            class="trg-outline pointer w-100p fs-12 dataset-editor-input-{{ input.id }}"
            [min]="startDate"
            [max]="maxDate"
            [disabled]="disabled || readonly"
            [matDatepicker]="endDatePicker"
            [(ngModel)]="endDate"
            (ngModelChange)="onEndDateChange($event)"
            (click)="endDatePicker.open()"
            readonly
            [required]="input.template.details.required || !!startDate"
          />
          <mat-datepicker-toggle matSuffix [for]="endDatePicker">
            <i class="far fa-calendar-alt i-16 p-relative mr-5" matDatepickerToggleIcon></i>
          </mat-datepicker-toggle>
          <mat-datepicker
            #endDatePicker
            [disabled]="disabled"
            startView="multi-year"
            (monthSelected)="relativeDatesEndDateMonthSelected($event, endDatePicker)"
            [panelClass]="noDate ? 'noDate' : ''"
          ></mat-datepicker>
          <i *ngIf="showEndDateClearValue()" class="far fa-times select-clear-btn" (click)="clearEndDateValue()"></i>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #yearPeriodInput>
  <div class="input-wrapper">
    <div class="date-input-wrapper">
      <input
        class="trg-outline pointer w-100p fs-12 dataset-editor-input-{{ input.id }}"
        [disabled]="disabled || readonly"
        [matDatepicker]="yearPeriodPicker"
        [(ngModel)]="yearPeriodDate"
        (ngModelChange)="onYearPeriodChange($event)"
        (click)="yearPeriodPicker.open()"
        readonly
        [required]="input.template.details.required"
      />
      <mat-datepicker-toggle matSuffix [for]="yearPeriodPicker">
        <i class="far fa-calendar-alt i-16 p-relative mr-5" matDatepickerToggleIcon></i>
      </mat-datepicker-toggle>
      <mat-datepicker
        #yearPeriodPicker
        [disabled]="disabled"
        startView="multi-year"
        (monthSelected)="yearPeriodSelected($event, yearPeriodPicker)"
        panelClass="noDate"
      ></mat-datepicker>
      <i *ngIf="showYearPeriodClearValue()" class="far fa-times select-clear-btn" (click)="clearYearPeriodValue()"></i>
    </div>
  </div>
</ng-template>
